import { render, staticRenderFns } from "./DeclareReport.vue?vue&type=template&id=2b9a0eb6&scoped=true&"
import script from "./DeclareReport.vue?vue&type=script&lang=js&"
export * from "./DeclareReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b9a0eb6",
  null
  
)

export default component.exports